import { types } from "./types";

const INITIAL_STATE = {
 
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case types.SET_XEMD_DETAILS.SUCCESS:
        return {
            ...state, 
            mapDetails: payload
        };
    case types.CLEAR_XEMD_DETAILS.SUCCESS:
        return {
            ...state, 
            mapDetails: null
        };
    case types.SET_ACTIVE_FORM_ID:
        return {
            ...state,
            activeFormId: payload,
        }; 
    default:
        return state;
    }
};

export default reducer;